import { ChevronDown, LogOut, User, Menu } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useProfile } from "../../context/ProfileContext";
const Header = ({ toggleSidebar }) => {
  const { profile } = useProfile();
  const location = useLocation().pathname;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    document.cookie = "refreshToken=; path=/; max-age=0;";
    window.location.href = "/";
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`navbar default-layout-navbar col-lg-12 col-12 p-0  d-flex flex-row ${location === "/" || location === "/forgot-password" ? "d-none" : ""
          }`}
      >
        <div className="navbar-brand-wrapper d-flex align-items-center">
          <Link className="navbar-brand brand-logo" to="/dashboard">
            <img src={`/logo.png`} alt="logo" className="logo-dark" />
          </Link>
          {/* <Link className="navbar-brand brand-logo" to="/dashboard">
            <img src={`/logo.svg`} alt="logo" className="logo-dark" />
          </Link>*/}
        </div>

        <div className=" d-flex align-items-center flex-grow-1">
          <div className="d-none d-sm-flex justify-content-center align-items-center w-100">
            <h4 className="mb-0 font-weight-normal text-center">
              Welcome to the Kyrus - Admin Panel
            </h4>
          </div>

          <ul className="navbar-nav navbar-nav-right ml-auto">
            <li
              className="nav-item dropdown d-none d-xl-inline-flex user-dropdown position-relative"
              ref={dropdownRef}
              style={{ right: "20px" }}
            >
              <span
                className="nav-link d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Admin
                <ChevronDown className="text-primary ml-2" size="17px" />
              </span>
              {dropdownOpen && (
                <div
                  className="dropdown-menu dropdown-menu-right show"
                  style={{
                    position: "absolute",
                    top: "110%",
                    right: 0,
                    minWidth: "230px",
                    zIndex: 9999,
                  }}
                >
                  <div className="dropdown-header text-center">
                    <p className="mb-1 text-dark font-weight-bold">
                      {profile?.fullName}
                    </p>
                    <p className="font-weight-light text-muted mb-0">
                      {profile?.email}
                    </p>
                  </div>

                  <Link
                    className="dropdown-item d-flex align-items-center"
                    to="/profile"
                  >
                    <User className="text-primary mr-2" size="20px" />
                    <span className="text-dark">My Profile</span>
                  </Link>

                  <Link
                    className="dropdown-item d-flex align-items-center"
                    to="/"
                    onClick={handleLogout}
                  >
                    <LogOut className="text-primary mr-2" size="20px" />
                    <span className="text-dark">Sign Out</span>
                  </Link>
                </div>
              )}
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
            onClick={toggleSidebar}
          >
            <Menu size={20} color="black" />
          </button>
        </div>
      </nav>
    </>
  );
};

export default Header;
